import { addDays } from 'date-fns';
import moment from 'moment-timezone';
import { formatDate } from 'src/utils/custom-formatters';

const isAmazon = window.location.href.indexOf('/amazon') > -1
const isFlipkart = window.location.href.indexOf('/flipkart') > -1
const isInstamart = window.location.href.indexOf('/instamart') > -1 
const isMyntra = window.location.href.indexOf('/myntra') > -1
const isBlinkit = window.location.href.indexOf('/blinkit') > -1
const isBillingpayment = window.location.href.indexOf('/billing-payments') > -1
const isZepto = window.location.href.indexOf('/zepto') > -1
const isBigbasket = window.location.href.indexOf('/bigbasket') > -1

function formatWithTimezone(date, timeZone) {
    return new Intl.DateTimeFormat('en-US', {
      timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }).format(date);
}



export const zoneToData = (localDate) => {
  const globalIdentifier = isAmazon ? 'selectedProfileId' : isFlipkart ? 'flipkartProfile' : isMyntra ? 'myntraProfile' : isInstamart ? 'instamartProfile' : isBlinkit ? 'blinkitProfile' : isZepto ? 'zeptoProfile' : isBigbasket ? 'bigbasketProfile' : ''
  const globalProfileDetails = globalIdentifier ? JSON.parse(sessionStorage.getItem(globalIdentifier)) : {}
  if (globalProfileDetails?.timezone) {
    const FormatedLocalDate = formatWithTimezone(new Date(localDate), globalProfileDetails?.timezone)
    return FormatedLocalDate
  } else {
    const FormatedLocalDate = formatWithTimezone(new Date(localDate), 'Asia/Kolkata')
    return FormatedLocalDate
  }
}

export const getCurrentDateInProfileTimezone = () => {
  const timeZone = getTimeZone()
  const now = new Date()
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  })
  const parts = formatter.formatToParts(now)
  const year = parseInt(parts.find(p => p.type === 'year').value)
  const month = parseInt(parts.find(p => p.type === 'month').value) - 1
  const day = parseInt(parts.find(p => p.type === 'day').value)
  const hour = parseInt(parts.find(p => p.type === 'hour').value)
  const minute = parseInt(parts.find(p => p.type === 'minute').value)
  const second = parseInt(parts.find(p => p.type === 'second').value)
  return new Date(year, month, day, hour, minute, second)
}

export const getLocalDate = (add = 0) => {
  const globalIdentifier = isAmazon ? 'selectedProfileId' : isFlipkart ? 'flipkartProfile' : isMyntra ? 'myntraProfile' : isInstamart ? 'instamartProfile' : isBlinkit ? 'blinkitProfile' : isZepto ? 'zeptoProfile' : isBigbasket ? 'bigbasketProfile'  : ''
  const globalProfileDetails = globalIdentifier ? JSON.parse(sessionStorage.getItem(globalIdentifier)) : {}
  let localDate = formatWithTimezone(add ? addDays(new Date(), add) : new Date(), 'Asia/Kolkata')
  if(!globalProfileDetails?.timezone) return localDate
  localDate = formatWithTimezone(add ? addDays(new Date(), add) : new Date(), globalProfileDetails?.timezone)
  return localDate
}

export const getTimeZoneAbrv = () => {
  const globalIdentifier = (isAmazon || isBillingpayment) ? 'selectedProfileId' : isFlipkart ? 'flipkartProfile' : isMyntra ? 'myntraProfile' : isInstamart ? 'instamartProfile' : isBlinkit ? 'blinkitProfile' : isZepto ? 'zeptoProfile' : isBigbasket ? 'bigbasketProfile'  : ''
  const globalProfileDetails = globalIdentifier ? JSON.parse(sessionStorage.getItem(globalIdentifier)) : {}
  const timeZone = globalProfileDetails?.timezone ? globalProfileDetails?.timezone : 'Asia/Kolkata'
  if(timeZone === 'Asia/Dubai') return 'GST'
  if(timeZone === 'America/Sao_Paulo') return 'BRT'
  if(timeZone === 'Asia/Riyadh') return 'AST'
  const currentTimeInTimezone = moment().tz(timeZone);
  return currentTimeInTimezone.format('z')
}

export const getTimeZone = () => {
  const globalIdentifier = (isAmazon || isBillingpayment)  ? 'selectedProfileId' : isFlipkart ? 'flipkartProfile' : isMyntra ? 'myntraProfile' : isInstamart ? 'instamartProfile' : isBlinkit ? 'blinkitProfile' : isZepto ? 'zeptoProfile' : isBigbasket ? 'bigbasketProfile'  : ''
  const globalProfileDetails = globalIdentifier ? JSON.parse(sessionStorage.getItem(globalIdentifier)) : {}
  const timeZone = globalProfileDetails?.timezone ? globalProfileDetails?.timezone : 'Asia/Kolkata'
  return timeZone
}


export const getCurrentProfileDetails = () => {
  const amazonProfile = JSON.parse(sessionStorage.getItem('selectedProfileId'));
  const flipkartProfile = JSON.parse(sessionStorage.getItem('flipkartProfile'));
  const myntraProfile = JSON.parse(sessionStorage.getItem('myntraProfile'));
  const blinkitProfile = JSON.parse(sessionStorage.getItem('blinkitProfile'));
  const instamartProfile = JSON.parse(sessionStorage.getItem('instamartProfile'));
  const zeptoProfile = JSON.parse(sessionStorage.getItem('zeptoProfile'));
  const bigbasketProfile = JSON.parse(sessionStorage.getItem('bigbasketProfile'));
 
  if (isAmazon) {
    return amazonProfile;
  } else if (isFlipkart) {
    return flipkartProfile;
  } else if (isMyntra) {
    return myntraProfile;
  } else if (isBlinkit) {
    return blinkitProfile;
  } else if (isInstamart) {
    return instamartProfile;
  } else if (isZepto) {
    return zeptoProfile;
  } else if (isBigbasket) {
    return bigbasketProfile;
  } else {
    return amazonProfile;
  }
}

export const getCurrentTDateAndTime = (date) => {
  const getProfile = getCurrentProfileDetails();
  const timeZone = getProfile?.timezone || 'Asia/Kolkata';
  const localMoment = moment(date).tz(timeZone);
  return localMoment.format('DD MMM, YYYY hh:mm A');
}

export const getAmazonProfileNextDay = (addDays = 1) => {
  const globalIdentifier = isAmazon ? 'selectedProfileId' : isFlipkart ? 'flipkartProfile' : isMyntra ? 'myntraProfile' : isInstamart ? 'instamartProfile' : isBlinkit ? 'blinkitProfile' : isZepto ? 'zeptoProfile' : isBigbasket ? 'bigbasketProfile' : ''
  const globalProfileDetails = globalIdentifier ? JSON.parse(sessionStorage.getItem(globalIdentifier)) : {}
  
  // Get the current time in the profile's timezone
  const profileTimezone = globalProfileDetails?.timezone || 'Asia/Kolkata'
  const nowInProfileTimezone = moment().tz(profileTimezone)
  
  // Add the specified number of days
  const nextDayInProfileTimezone = nowInProfileTimezone.clone().add(addDays, 'days')
  
  // Get the start of that day in the profile's timezone
  const startOfDayInProfileTz = nextDayInProfileTimezone.startOf('day')
  
  // Create a date string in YYYY-MM-DD format
  const dateString = startOfDayInProfileTz.format('YYYY-MM-DD')
  
  // Create a Date object by parsing the date string components directly
  const [year, month, day] = dateString.split('-').map(Number)
  const resultDate = new Date(year, month - 1, day) // month is 0-indexed in Date constructor
  
  // Debug log to see all values
  // console.log('🔍 getAmazonProfileNextDay debug:', { 
  //   addDays, 
  //   globalIdentifier, 
  //   globalProfileDetails, 
  //   profileTimezone, 
  //   nowInProfileTimezone: nowInProfileTimezone.format('YYYY-MM-DD HH:mm:ss z'), 
  //   nextDayInProfileTimezone: nextDayInProfileTimezone.format('YYYY-MM-DD HH:mm:ss z'), 
  //   startOfDayInProfileTz: startOfDayInProfileTz.format('YYYY-MM-DD HH:mm:ss z'),
  //   dateString,
  //   year, month, day,
  //   resultDate,
  //   formattedDate: formatDate(resultDate),
  //   systemTime: new Date().toISOString(),
  //   systemTimeInProfileTz: moment().tz(profileTimezone).format('YYYY-MM-DD HH:mm:ss z')
  // });

  return resultDate
}